import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsProps } from "antd";
import CandidatesPageHeader from "./components/CandidatesPageHeader";
import TalentPoolFilterMenu from "./components/TalentPoolFilterMenu";
import TalentPoolTable from "./components/TalentPoolTable";
import "./index.scss";
import useTalentPool from "../../Hooks/useTalentPool";

const validTabs = [
  "all",
  "resume-submissions",
  "applied-by-candidate",
  "applied-by-recruiter",
] as const;
type Tab = (typeof validTabs)[number];

const Candidates: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const tab: Tab = validTabs.includes(tabParam as Tab)
    ? (tabParam as Tab)
    : "all";

  const {
    loading,
    filters,
    pagination,
    users,
    updatePagination,
    updateFilters,
    clearFilter,
  } = useTalentPool(tab);

  const items: TabsProps["items"] = [
    {
      key: "all",
      label: "All",
    },
    {
      key: "resume-submissions",
      label: "Resume Submissions",
    },
    {
      key: "applied-by-candidate",
      label: "Applied By Candidate",
    },
    {
      key: "applied-by-recruiter",
      label: "Applied By Recruiter",
    },
  ];

  const handleTabChange = (key: string) => {
    const changedTab: Tab = validTabs.includes(key as Tab)
      ? (key as Tab)
      : "all";
    setSearchParams({ tab: changedTab }, { replace: true });
    const source =
      changedTab === "resume-submissions"
        ? "direct_upload"
        : changedTab === "applied-by-candidate"
          ? "job_application"
          : changedTab === "applied-by-recruiter"
            ? "bulk_upload"
            : null;
    updateFilters("source", source);
  };

  return (
    <div className="candidates-page">
      <CandidatesPageHeader />
      <Tabs
        activeKey={tab}
        onChange={handleTabChange}
        items={items}
        size="small"
      />
      <TalentPoolFilterMenu
        loading={loading}
        filters={filters}
        clearFilter={clearFilter}
        updateFilters={updateFilters}
      />
      <TalentPoolTable
        loading={loading}
        users={users}
        pagination={pagination}
        updatePagination={updatePagination}
      />
    </div>
  );
};

export default Candidates;
